import { call } from '@advanza/api'
import LoginBox from '@trustoo/components/login/LoginBox'
import LoginButton from '@trustoo/components/login/LoginButton'
import { getLogoUrls } from '@trustoo/utils/localeUtils'
import LoginError from 'components/login/LoginError'
import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

const Logout = () => {
    const [redirect, setRedirect] = useState('')
    const [error, setError] = useState('')
    const isLoggedIn = Boolean(window._user)

    useEffect(() => {
        if (isLoggedIn) {
            call('auth/logout/1').then(
                // A full reload, so the app forgets the user too
                () => window.location.assign(`/logout${window.location.search}`),
                (response: { error?: string }) =>
                    setError(response.error ?? 'Something went wrong'),
            )
        }
    }, [])

    if (redirect) {
        return <Navigate to={redirect} replace />
    }

    return (
        <LoginBox title="Log out" logoUrl={getLogoUrls().default} isLoading={isLoggedIn && !error}>
            <div className="flex flex-col gap-4 pt-4">
                {!isLoggedIn && (
                    <>
                        <p className="m-0">You are now logged out</p>
                        <LoginButton
                            onClick={() => setRedirect(`/login${window.location.search}`)}
                            className="w-full">
                            Log in
                        </LoginButton>
                    </>
                )}
                {error && <LoginError message={error} />}
            </div>
        </LoginBox>
    )
}

export default Logout
